<template>
	<div class="exhibition">
		<div class="content">
			<div class="title">
				储能<span>精算</span>师
				<div class="second-title">/ 更准的储能测算</div>
			</div>

			<div class="step-cards">
				<div v-for="(item, index) in steps" :key="index" class="step">
					<div class="step-left">
						<div class="step-left-top">
							<img src="@/assets/images/circle.png" alt="" />
						</div>
						<div class="step-left-bottom">
							<div
								v-if="index != steps.length - 1"
								class="gradiation"
							></div>
						</div>
					</div>
					<div class="step-right">
						<div class="step-right-top">
							{{ item.title }}
						</div>
						<div class="step-right-bottom">
							{{ item.info }}
						</div>
					</div>
				</div>
			</div>
			<div @click="goLogin" class="btn">免费体验</div>
		</div>
	</div>
</template>

<script setup>
	import { ref } from "vue";
	import { useRouter, useRoute } from "vue-router";
	const router = useRouter();
	const steps = ref([
		{
			title: "负载分析",
			info: "上传负载数据 智能分析负载情况"
		},
		{
			title: "配储评估",
			info: "高精度模拟计算 更接近真实配储效果"
		},
		{
			title: "经济分析",
			info: "经济指标分析 方案产出更进一步"
		},
		{
			title: "测算报告",
			info: "形成图文报告 PC/手机双端查看"
		}
	]);

	const goLogin = () => {
		router.push("/login");
	};
</script>

<style lang="less" scoped>
	.exhibition {
		height: 100%;
		.content {
			position: absolute;
			top: 15vh;
			left: 17.13vw;

			.title {
				color: #000000d9;
				font-size: 56px;
				font-family: PingFangSC;
				font-weight: 600;
				// line-height: 5.9vh;
				letter-spacing: 4px;
				-moz-stack-sizing: 0;
				text-align: left;
				display: flex;
				align-items: flex-end;
				// position: relative;
				span {
					color: #0058fc;
				}

				.second-title {
					height: 32px;
					font-family: PingFangSC-Regular;
					font-weight: 400;
					font-size: 24px;
					color: #000000d9;
					letter-spacing: 0;
					line-height: 32px;
					margin-right: 8px;
				}
			}

			.step-cards {
				margin-top: 4.44vh;
				.step {
					display: flex;
					&-left {
						display: flex;
						justify-content: center;
						flex-wrap: wrap;
						width: 20px;
						margin-bottom: 4px;
						&-top {
							img {
								width: 20px;
								height: 20px;
							}
							margin-bottom: 4px;
						}
						&-bottom {
							.gradiation {
								width: 2px;
								height: 6vh;
								background: linear-gradient(
									180deg,
									#0058fc,
									rgba(0, 88, 252, 0.1)
								);
							}
						}
					}
					&-right {
						margin-left: 8px;
						&-top {
							font-family: PingFangSC-Medium;
							font-weight: 600;
							font-size: 18px;
							color: #000000d9;
							letter-spacing: 0;
							margin-bottom: 4px;
						}
						&-bottom {
							height: 23px;
							font-family: PingFangSC-Regular;
							font-weight: 400;
							font-size: 15px;
							color: #000000a6;
							letter-spacing: 0;
							line-height: 23px;
						}
					}
				}
			}

			.btn {
				width: 176px;
				height: 56px;
				background: #0058fc;
				border-radius: 4px;

				font-family: PingFangSC-Medium;
				font-weight: 500;
				font-size: 20px;
				color: #ffffff;
				letter-spacing: 0;
				line-height: 28px;
				display: flex;
				justify-content: center;
				align-items: center;
                margin-top: 40px;
                cursor: pointer;
			}
		}
	}
</style>
